// extracted by mini-css-extract-plugin
module.exports = {"TitleWrapper":"title-wrapper_TitleWrapper__pxNT9","TitleWrapper__link-wrapper":"title-wrapper_TitleWrapper__link-wrapper__q0T5z"};